export const SERVER_RESPONSE = {
    SUCCESS : 'Message has been sent.'
 }